module.exports = __webpack_public_path__ + "static/img/shangjia1.c25778f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/shangjia1.jpg
// module id = 1420
// module chunks = 1